/**
 * LRRS Motor – Keystone Product Options customizations
 *
 * 1) French translations for Keystone default texts (FR locale only)
 * 2) Fix for the merchant's WhatsApp / Telegram / E-mail buttons (#lrrs-contact-root)
 *    - sends ALL selected options with their real labels + final price
 *    - hides the contact card on products tagged "masquer-contact"
 *    - slightly enlarges the card for better visibility
 *
 * The merchant's own code is left untouched – this script intercepts
 * the button click (capture phase) before the merchant's handler runs.
 */

var LRRS_DEBUG = false;

function lrrsLog() {
  if (!LRRS_DEBUG || !window.console) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift('[LRRS]');
  console.log.apply(console, args);
}

/* =========================================================
   1) TRANSLATIONS (FR locale only)
   ========================================================= */
(function () {
  var locale = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || '').toLowerCase();
  if (locale.indexOf('fr') !== 0) {
    lrrsLog('Translations skipped, locale is:', locale || '(unknown)');
    return;
  }

  // Exact text node replacements inside the Keystone totals box
  var TEXT_MAP = {
    'Total Extras': 'Total des options',
    'Total extras': 'Total des options',
    'Base Product Price:': 'Prix de base du produit :',
    'Total Price:': 'Prix total :'
  };

  // Input / textarea placeholders
  var PLACEHOLDER_MAP = {
    'Enter text': 'Saisir du texte'
  };

  function translateAll() {
    var block = document.getElementById('key_options_block');
    if (!block) return;

    var count = 0;

    // Totals box texts
    var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.trim();
      if (TEXT_MAP[t]) {
        node.nodeValue = node.nodeValue.replace(t, TEXT_MAP[t]);
        count++;
      }
    }

    // Text field placeholders
    block.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      var p = (el.getAttribute('placeholder') || '').trim();
      if (PLACEHOLDER_MAP[p]) {
        el.setAttribute('placeholder', PLACEHOLDER_MAP[p]);
        count++;
      }
    });

    // Dropdown placeholders: "Choose" / "Choose <option title>" -> "Choisir ..."
    block.querySelectorAll('select option[value=""]').forEach(function (opt) {
      var o = opt.textContent.trim();
      if (/^Choose\b/.test(o)) {
        opt.textContent = o.replace(/^Choose\b/, 'Choisir');
        count++;
      }
    });

    if (count) lrrsLog('Translated', count, 'element(s)');
  }

  // Debounce re-translation to one run per animation frame
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      translateAll();
    });
  }

  var started = false;
  function start() {
    if (started) return;
    var block = document.getElementById('key_options_block');
    if (!block) {
      lrrsLog('Keystone block not found yet, waiting for key:options:ready');
      return;
    }
    started = true;
    lrrsLog('Translations initialized');
    translateAll();

    // Keystone re-renders parts of the form (conditional logic, price box),
    // so watch the block and translate again whenever it changes
    new MutationObserver(schedule).observe(block, { childList: true, subtree: true, characterData: true });

    if (window.KeyOptions && typeof window.KeyOptions.on === 'function') {
      window.KeyOptions.on('price-updated', schedule);
    }
  }

  document.addEventListener('key:options:ready', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* =========================================================
   2) CONTACT BUTTONS (WhatsApp / Telegram / E-mail)
   ========================================================= */
(function () {
  var PHONE = '33767700271';
  var EMAIL = 'lrrsmotor@gmail.com';
  var HIDE_TAG = 'masquer-contact';
  var LINE = '━━━━━━━━━━━━━━━━━━━━';
  var SUB = '────────────────────';

  function getBlock() {
    return document.getElementById('key_options_block');
  }

  /* --- Card visibility styles --- */
  var style = document.createElement('style');
  style.textContent =
    '#lrrs-contact-root .lrrs-title{font-size:16px}' +
    '#lrrs-contact-root .lrrs-sub{font-size:12px}' +
    '#lrrs-contact-root .lrrs-btn{padding:14px 6px;gap:8px}' +
    '#lrrs-contact-root .icon-box{width:40px;height:40px}' +
    '#lrrs-contact-root .icon-box svg{width:20px;height:20px}' +
    '#lrrs-contact-root .btn-label{font-size:11px}';
  document.head.appendChild(style);

  /* --- Hide the card on products tagged HIDE_TAG --- */
  function applyTagVisibility() {
    var block = getBlock();
    var card = document.getElementById('lrrs-contact-root');
    if (!block || !card) return;

    var tags = (block.getAttribute('data-product-tags') || '')
      .toLowerCase()
      .split(',')
      .map(function (t) { return t.trim(); });

    if (tags.indexOf(HIDE_TAG) !== -1) {
      card.style.display = 'none';
      lrrsLog('Contact card hidden (product has tag "' + HIDE_TAG + '")');
    }
  }

  document.addEventListener('key:options:ready', applyTagVisibility);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyTagVisibility);
  else applyTagVisibility();

  /* --- Price --- */
  var lastTotalCents = null;
  var priceHooked = false;

  function hookPrice() {
    if (priceHooked || !window.KeyOptions || typeof window.KeyOptions.on !== 'function') return;
    priceHooked = true;
    window.KeyOptions.on('price-updated', function (d) {
      if (d && typeof d.totalPriceCents === 'number') {
        lastTotalCents = d.totalPriceCents;
        lrrsLog('Price updated (cents):', lastTotalCents);
      }
    });
  }

  hookPrice();
  document.addEventListener('key:options:ready', hookPrice);

  function getPrice() {
    // 1) "Prix total" / "Total Price" from the Keystone totals box (what the customer sees)
    var block = getBlock();
    if (block) {
      var best = '';
      block.querySelectorAll('*').forEach(function (el) {
        if (el.children.length > 4) return;
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (!t || t.length > 80 || !/(Prix total|Total Price)/i.test(t) || !/\d/.test(t)) return;
        if (!best || t.length < best.length) best = t;
      });
      if (best) {
        var fromBox = best.replace(/^.*?(Prix total|Total Price)\s*:?\s*/i, '').trim();
        lrrsLog('Price taken from totals box:', fromBox);
        return fromBox;
      }
    }

    // 2) Fallback: last price from the Keystone price-updated event
    if (typeof lastTotalCents === 'number' && lastTotalCents > 0) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var formatted;
      try {
        formatted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(lastTotalCents / 100);
      } catch (e) {
        formatted = (lastTotalCents / 100).toFixed(2) + ' ' + cur;
      }
      lrrsLog('Price taken from Keystone event:', formatted);
      return formatted;
    }

    lrrsLog('No price found, price section will be omitted');
    return '';
  }

  /* --- Options --- */

  // Option title without the " *" and "(required)" helper spans
  function cleanLabel(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    c.querySelectorAll('[aria-hidden="true"], .key_sr_only').forEach(function (n) { n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim().replace(/\s*:\s*$/, '');
  }

  // Values are read from the value attribute (original French values),
  // so they don't depend on storefront language or browser translation
  function getValues(w) {
    var vals = [];

    // Dropdowns (empty value = placeholder, skipped)
    w.querySelectorAll('select').forEach(function (s) {
      if (s.value) vals.push(s.value);
    });

    // Swatches / radios / checkboxes
    w.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (i) {
      if (i.value) vals.push(i.value);
    });
    if (!vals.length) {
      w.querySelectorAll('[aria-checked="true"] input').forEach(function (i) {
        if (i.value) vals.push(i.value);
      });
    }

    // Text fields
    w.querySelectorAll('input[type="text"], input[type="number"], input[type="email"], input[type="tel"], input[type="date"], textarea').forEach(function (i) {
      var v = (i.value || '').trim();
      if (v) vals.push(v);
    });

    // File uploads (file name only – the file itself can't be sent via link)
    w.querySelectorAll('input[type="file"]').forEach(function (i) {
      if (i.files && i.files.length) {
        Array.prototype.forEach.call(i.files, function (f) { vals.push('📎 ' + f.name); });
      }
    });

    // Remove duplicates
    return vals.filter(function (v, idx, arr) { return arr.indexOf(v) === idx; });
  }

  function getOptionLines() {
    var block = getBlock();
    var lines = [];
    if (!block) {
      lrrsLog('Keystone block not found, no options collected');
      return lines;
    }

    block.querySelectorAll('.key_option_wrapper').forEach(function (w) {
      if (w.getAttribute('data-option-type') === 'divider') return;
      if (!w.getClientRects().length) return; // hidden by conditional logic

      var vals = getValues(w);
      if (!vals.length) return;

      lines.push('• ' + cleanLabel(w.querySelector('.key_option_title')) + ' : ' + vals.join(', '));
    });

    lrrsLog('Collected', lines.length, 'selected option(s):', lines);
    return lines;
  }

  function getProductTitle() {
    var block = getBlock();
    var t = block && block.getAttribute('data-product-title');
    if (t) return t;
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* --- Message (same format as the merchant's original) --- */
  function buildMessage() {
    var lines = getOptionLines();
    var price = getPrice();

    var msg = [
      LINE, '🚗 DEMANDE DE VISUEL', 'LRRS MOTOR', LINE, '',
      '📦 PRODUIT', getProductTitle(), '',
      '⚙️ CONFIGURATION SÉLECTIONNÉE', SUB
    ].concat(lines.length ? lines : ['• Configuration standard']);

    if (price) {
      msg = msg.concat(['', '💰 PRIX FINAL', SUB, price]);
    }

    msg = msg.concat([
      '', '📝 DEMANDE', SUB,
      'Je souhaite recevoir une simulation visuelle',
      'correspondant à cette configuration.', '',
      '🔗 LIEN DU PRODUIT', SUB, window.location.href, '',
      'Merci pour votre retour. 😊', 'LRRS MOTOR • SERVICE SUR MESURE', LINE
    ]);

    return msg.join('\n');
  }

  /* --- Click handler: capture phase, runs BEFORE the merchant's handler --- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#lrrs-wa, #lrrs-tg, #lrrs-mail');
    if (!btn) return;

    // Stop the merchant's original handler from running
    e.preventDefault();
    e.stopImmediatePropagation();

    var enc = encodeURIComponent;
    var message = buildMessage();
    lrrsLog('Button clicked:', btn.id);
    lrrsLog('Message:\n' + message);

    if (btn.id === 'lrrs-wa') {
      window.open('https://wa.me/' + PHONE + '?text=' + enc(message), '_blank');
    } else if (btn.id === 'lrrs-tg') {
      window.open('https://t.me/share/url?url=' + enc(window.location.href) + '&text=' + enc(message), '_blank');
    } else {
      window.location.href = 'mailto:' + EMAIL +
        '?subject=' + enc('Demande de visuel - ' + getProductTitle()) +
        '&body=' + enc(message);
    }
  }, true);

  lrrsLog('Contact button fix initialized');
})();